import script from "./HereditaryCaseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HereditaryCaseItem.vue?vue&type=script&setup=true&lang=js"

import "./HereditaryCaseItem.vue?vue&type=style&index=0&id=65506616&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65506616"]])

export default __exports__